/*
 * File: /src/services/contentBlock.js
 * Created Date: Thursday November 4th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 28th November 2021 11:32:18 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_CONTENT_BLOCK_PATH } from '../constants';

export default {
  /**
   * Fetch All Content Blocks
   *
   * @returns
   */
  fetchAll(params) {
    if (!params) {
      params = {};
    }
    params['sort'] = 'label:asc';
    return authedAxios.get(AD_BASE_CONTENT_BLOCK_PATH, { params: params });
  },

  fetchById(id) {
    return authedAxios.get(AD_BASE_CONTENT_BLOCK_PATH + id, {});
  },

  updateContentBlock(id, payload) {
    return authedAxios.put(AD_BASE_CONTENT_BLOCK_PATH + id, payload);
  },

  createContentBlock(payload) {
    return authedAxios.post(AD_BASE_CONTENT_BLOCK_PATH, payload);
  },

  softDelete(id) {
    return authedAxios.delete(`${AD_BASE_CONTENT_BLOCK_PATH}${id}`);
  },
};
